import React from 'react';
import {Edit, SimpleForm} from 'react-admin';

import {CustomToolbar, Grid} from '../../components'
import QuestionFields from './QuestionFields'

export const QuestionEdit = props => (
    <Edit {...props}>
        <SimpleForm toolbar={<CustomToolbar/>}>
            <Grid container spacing={8}>
                <QuestionFields/>
            </Grid>
        </SimpleForm>
    </Edit>
);

export default QuestionEdit
